import React from "react";
import get from "lodash/get";
import { object } from "prop-types";
import TimeStamp from "../../../atoms/time-stamp";

import "./key-highlights.m.css";

function getTitleElement(elements) {
  return elements.find(element => element.type === "title");
}

function titleText(card) {
  const text = getTitleElement(card["story-elements"]);
  return text ? text.text : "";
}

const goToCard = cardId => {
  if (cardId) {
    setTimeout(function() {
      document.getElementById(cardId) &&
        document.getElementById(cardId).scrollIntoView({
          behavior: "smooth",
          block: "start",
          inline: "nearest"
        });
    }, 100);
  }
};

const KeyHighlight = ({ highlight }) => (
  <li styleName="list-key" onClick={() => goToCard(highlight.card.id)}>
    <span styleName="clock-icon">
      <img src="/assetify/clock.svg" alt="email" width="14" />
    </span>
    <TimeStamp prefix="" timeStamp={highlight.card["card-added-at"]} />
    <h3 styleName="headline">{highlight.title}</h3>
  </li>
);

const KeyHighlights = props => {
  const { story } = props;
  const keyhighlights = story.cards
    .filter(card => get(card, ["metadata", "attributes", "key-event"], false))
    .map(card => {
      return { title: titleText(card), card };
    });

  return keyhighlights.length > 0 ? (
    <div styleName="wrapper">
      <h3 styleName="main-headline">Päätapahtumat</h3>
      <ul styleName="list">
        {keyhighlights.slice(0, 5).map(highlight => (
          <KeyHighlight key={`highlight-${highlight.card.id}`} highlight={highlight} />
        ))}
      </ul>
    </div>
  ) : null;
};

KeyHighlight.propTypes = {
  highlight: object
};

KeyHighlights.propTypes = {
  story: object
};

export default KeyHighlights;
